export const OVERSIZED_TASK_SELECTION_THRESHOLD = 1000

/**
 * Collapse huge nested task selections to project-level IDs so remount/persist
 * does not freeze the UI or explode localStorage.
 * Folders are left intact (usually small).
 */
export function collapseOversizedTaskSelection ({
  selectedProjects = [],
  selectedTasks = [],
  selectedFolders = [],
  selectionScopeProjectIds = []
} = {}) {
  const projects = Array.isArray(selectedProjects) ? selectedProjects : []
  const tasks = Array.isArray(selectedTasks) ? selectedTasks : []
  const folders = Array.isArray(selectedFolders) ? selectedFolders : []
  const scope = Array.isArray(selectionScopeProjectIds) ? selectionScopeProjectIds : []

  if (tasks.length <= OVERSIZED_TASK_SELECTION_THRESHOLD || !scope.length) {
    return {
      selectedProjects: projects,
      selectedTasks: tasks,
      selectedFolders: folders,
      selectionScopeProjectIds: scope,
      collapsedFromNestedTasks: false
    }
  }

  return {
    selectedProjects: [...new Set([
      ...projects.map(id => String(id)),
      ...scope.map(id => String(id))
    ])],
    selectedTasks: [],
    selectedFolders: folders,
    selectionScopeProjectIds: scope,
    collapsedFromNestedTasks: true
  }
}

/** Build the v-model payload emitted by the manager-reports project tree. */
export function buildSelectionPayload (selects, collapsedFromNestedTasks = false) {
  const list = Array.isArray(selects) ? selects : []
  return {
    selectedProjects: list.filter(t => t.Type === 'Project').map(i => i.Project_ID),
    selectedTasks: list.filter(t => t.Type === 'Task').map(i => i.Item_ID),
    selectedFolders: list.filter(t => t.Type === 'Folder').map(i => i.Item_ID),
    selectionScopeProjectIds: [...new Set(
      list.map(i => i.Project_ID).filter(id => id != null)
    )],
    collapsedFromNestedTasks: !!collapsedFromNestedTasks
  }
}
